module.exports = __webpack_public_path__ + "img/register.9aa4f912.png";